import PropTypes from 'prop-types';
import { BACKGROUND_PREFERENCES, GENDER_OPTIONS } from '../../../../../config/dataConfig/FJHeadshotGeneratorData';
import OptionCard from '../OptionCard';

import styles from './StepForm.module.less';
import FJLocalStore from '../../../../../store/FJLocalStore';
import { useMemo } from 'react';
import FJConfig from '../../../../../config/FJConfig';
import FJFileHandleUtil from '../../../../../util/FJFileHandleUtil';

/**
 * 背景偏好选择器, 支持多选
 */
const FJBackgroundPreferenceSelector = ({
    selectedBackgroundPreference,
    onBackgroundPreferenceChange,
    gender = GENDER_OPTIONS.MALE,
}) => {
    const currentBackgroundOptions = useMemo(() => {
        return BACKGROUND_PREFERENCES.filter(background => background.gender === gender);
    }, [gender]);

    const handleBackgroundPreferenceChange = option => {
        // 检查当前选中的选项数量
        const currentSelectedCount = selectedBackgroundPreference.length;
        const isCurrentlySelected = selectedBackgroundPreference.findIndex(item => item.key === option.key) !== -1;

        // 如果当前只有一个选项被选中，且用户要取消选择它，则禁用撤销
        if (currentSelectedCount === 1 && isCurrentlySelected) {
            // 禁用撤销功能 - 不允许取消最后一个选项
            return;
        }

        // 否则正常处理选择变化
        onBackgroundPreferenceChange(option);
    };

    return (
        <div className={styles.step_form}>
            <h3 className={styles.step_title}>{FJLocalStore._('select-your-background-preference')}</h3>
            <div className={styles.options_grid}>
                {currentBackgroundOptions.map(option => (
                    <OptionCard
                        key={option.key}
                        title={FJLocalStore._(option.key)}
                        imageUrl={FJFileHandleUtil.getImageUrlWithFormat(
                            `${FJConfig.headshotImagePath}${option.imageUrl}?v=${FJConfig.version}`,
                        )}
                        isSelected={selectedBackgroundPreference.findIndex(item => item.key === option.key) !== -1}
                        onClick={() => handleBackgroundPreferenceChange(option)}
                        multiple
                    />
                ))}
            </div>
        </div>
    );
};

FJBackgroundPreferenceSelector.propTypes = {
    selectedBackgroundPreference: PropTypes.array,
    onBackgroundPreferenceChange: PropTypes.func,
    gender: PropTypes.string,
};

export default FJBackgroundPreferenceSelector;
